import { useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

// `field` indica la chiave di inputData da aggiornare (default 'description';
// usato anche per 'servicesIncluded' nel wizard di prenotazione).
const QuillTextarea = ({ initContent, setInputData, field = 'description' }) => {
    const [quillContent, setQuillContent] = useState('');
    useEffect(() => {
        setInputData(prevState => ({
            ...prevState,
            [field]: quillContent
        }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [quillContent])

    const [isFirstDone, setIsForstDone] = useState(false);
    useEffect(() => {
        if(initContent && !isFirstDone) {
            setQuillContent(initContent);
            setIsForstDone(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initContent])
    return (
        <ReactQuill value={quillContent} onChange={setQuillContent} />
    )
}

export default QuillTextarea;